import * as React from 'react';
import {withPhpJs} from './index';

export const withSessionErrors = (Inner: any) =>
  withPhpJs(({sessionErrors}) => ({
    initialErrors: sessionErrors,
  }))((props: any) => <Inner {...props} />);
